import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';
import Mapa from '../../components/Mapa';
import Historial from '../../components/Historial';
import './PanelGuardia.css';

const ANCHO_MAPA_BASE = 1120;
const ALTO_MAPA_BASE  = 620;

const PanelAdmin = ({ rolUsuario }) => {

  const [vista, setVista] = useState(() => {
    const vistaGuardada = localStorage.getItem('vistaPanelAdmin');
    return vistaGuardada ? vistaGuardada : 'mapa';
  });

  useEffect(() => {
    localStorage.setItem('vistaPanelAdmin', vista);
  }, [vista]);

  const [usuarios, setUsuarios]         = useState([]);
  const [filtroNombre, setFiltroNombre] = useState('');
  const [filtroPatente, setFiltroPatente] = useState('');
  const [filtroInicio, setFiltroInicio] = useState('');
  const [filtroFin, setFiltroFin]       = useState('');
  const [descargandoExcel, setDescargandoExcel] = useState(false);
  const [mensaje, setMensaje]           = useState(null);
  const [triggerGeneral, setTriggerGeneral] = useState(0);
  const [bloqueoFoco, setBloqueoFoco]   = useState(false);
  const [paso, setPaso]                 = useState(1);
  const [nombreTemporal, setNombreTemporal] = useState('');
  const [rutTemporal, setRutTemporal]   = useState('');
  const [inputValue, setInputValue]     = useState('');
  const [procesando, setProcesando]     = useState(false);
  const [datosMapa, setDatosMapa]       = useState(null);
  const [mostrarMover, setMostrarMover] = useState(false);
  const [modalVisita, setModalVisita]   = useState(false);
  const [lugarPendiente, setLugarPendiente] = useState(null);
  const [nombreVisita, setNombreVisita] = useState('');
  const [patenteVisita, setPatenteVisita] = useState('');
  const [zonaVisita, setZonaVisita]     = useState('');
  const [nuevoUser, setNuevoUser]       = useState({ username:'', password:'', first_name:'', last_name:'', rol:'Guardia' });
  const [escala, setEscala]             = useState(1);

  // --- ESTADOS PARA CARGA MASIVA Y VACIADO DE FUNCIONARIOS ---
  const [archivoBD, setArchivoBD]       = useState(null);
  const [procesandoBD, setProcesandoBD] = useState(false);

  // --- ESTADOS PARA EDICIÓN INDIVIDUAL (CRUD CON BÚSQUEDA) ---
  const [terminoBusqueda, setTerminoBusqueda] = useState(''); 
  const [resultadosBusqueda, setResultadosBusqueda] = useState([]); 
  const [funcionarioEdit, setFuncionarioEdit] = useState(null);
  const [procesandoEdit, setProcesandoEdit] = useState(false);

  // --- ESTADOS PARA RESERVA DE ESTACIONAMIENTO ---
  const puedeReservar = ['Jefe de Servicios Digitales', 'Jefe de Seguridad', 'Subdirectora de Sede'].includes(rolUsuario);
  const [reservaLugar, setReservaLugar] = useState('');
  const [reservaRut, setReservaRut] = useState('');
  const [reservaNombre, setReservaNombre] = useState('');
  const [reservaPatente, setReservaPatente] = useState('');
  const [reservaMotivo, setReservaMotivo] = useState('');
  const [reservaInstitucion, setReservaInstitucion] = useState('');
  const [institucionVisita, setInstitucionVisita] = useState('');

  const inputRef       = useRef(null);
  const inputNombreRef = useRef(null);
  const rutActualRef   = useRef('');
  const contenedorRef = useRef(null);

  useEffect(() => {
    const calcularEscala = () => {
      if (!contenedorRef.current) return;
      const anchoDisponible = contenedorRef.current.offsetWidth - 20;
      setEscala(anchoDisponible < ANCHO_MAPA_BASE ? anchoDisponible / ANCHO_MAPA_BASE : 1);
    };
    const ro = new ResizeObserver(calcularEscala);
    if (contenedorRef.current) ro.observe(contenedorRef.current);
    calcularEscala();
    return () => ro.disconnect();
  }, []);

  const altoEscalado = Math.round(ALTO_MAPA_BASE * escala);

  useEffect(() => { if (vista === 'usuarios') cargarUsuarios(); }, [vista]);

  useEffect(() => {
    if (vista !== 'mapa') return;
    const enfocar = () => {
      if (!bloqueoFoco && !modalVisita && !mostrarMover) inputRef.current?.focus();
      if (modalVisita) setTimeout(() => inputNombreRef.current?.focus(), 100);
    };
    enfocar();
    if (!bloqueoFoco && !modalVisita && !mostrarMover)
      window.addEventListener('click', enfocar);
    return () => window.removeEventListener('click', enfocar);
  }, [bloqueoFoco, mensaje, paso, modalVisita, vista, mostrarMover]);

  useEffect(() => {
    if (mensaje?.tipo !== 'info') {
      const t = setTimeout(() => setMensaje(null), 4000);
      return () => clearTimeout(t);
    }
  }, [mensaje]);

  const cargarUsuarios = async () => {
    try { const res = await api.get('/api/admin/usuarios/'); setUsuarios(res.data); }
    catch (e) { console.error(e); }
  };

  const handleCrearUsuario = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/admin/usuarios/', nuevoUser);
      alert(`Usuario ${nuevoUser.username} creado`);
      setNuevoUser({ username:'', password:'', first_name:'', last_name:'', rol:'Guardia' });
      cargarUsuarios();
    } catch (err) { alert(err.response?.data?.error || "Error al crear"); }
  };

  const handleEliminar = async (id, nombre) => {
    if (!window.confirm(`¿Eliminar a ${nombre}?`)) return;
    try { await api.delete('/api/admin/usuarios/', { params:{ id } }); cargarUsuarios(); }
    catch (err) { alert(err.response?.data?.error || "Error"); }
  };

  // --- FUNCIÓN: VACIAR BASE DE DATOS COMPLETA ---
  const handleVaciarBaseDatos = async () => {
    if (!window.confirm("⚠️ ALERTA ROJA ⚠️\n\nEstás a punto de ELIMINAR TODOS LOS FUNCIONARIOS de la base de datos. Esta acción no se puede deshacer.\n\n¿Deseas continuar?")) {
        return;
    }
    if (!window.confirm("¿Estás 100% seguro? Toda la información de patentes y cargos desaparecerá hasta que subas un nuevo archivo Excel.")) {
        return;
    }

    setProcesandoBD(true);
    try {
        const res = await api.delete('/api/funcionarios/vaciar/');
        alert(res.data.mensaje);
        setTriggerGeneral(p => p + 1); 
    } catch (err) {
        alert(err.response?.data?.error || "Error al vaciar la base de datos");
    } finally {
        setProcesandoBD(false);
    }
  };

  // --- FUNCIÓN: CARGAR BASE DE DATOS EXCEL ---
  const handleCargarBD = async (e) => {
    e.preventDefault();
    if (!archivoBD) return alert("Por favor selecciona un archivo Excel o CSV.");
    setProcesandoBD(true);
    const formData = new FormData();
    formData.append('archivo', archivoBD);
    try {
      const res = await api.post('/api/funcionarios/cargar/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 60000 
      });
      alert(res.data.mensaje);
      setArchivoBD(null); 
      document.getElementById('input-bd').value = ''; 
      setTriggerGeneral(p => p + 1); 
    } catch (err) {
      if (err.response?.status === 401) { alert("⛔ Tu sesión ha expirado."); } 
      else if (err.response?.status === 403) { alert("⛔ Acceso denegado."); } 
      else {
        if (err.code === 'ECONNABORTED') { alert("⏳ Archivo muy grande. Procesando en segundo plano."); } 
        else { alert("❌ Error: " + (err.response?.data?.error || err.response?.data?.detail || "Falla técnica")); }
      }
    } finally { setProcesandoBD(false); }
  };

  // --- LÓGICA DE BÚSQUEDA Y EDICIÓN (CRUD) ---
  const handleBuscarParaEditar = async (e) => {
    e.preventDefault();
    if (!terminoBusqueda) return alert("Ingresa un RUT o Nombre para buscar");
    
    setProcesandoEdit(true);
    setResultadosBusqueda([]); 
    setFuncionarioEdit(null);

    try {
      const res = await api.get(`/api/funcionarios/editar/?q=${terminoBusqueda}`);
      const coincidencias = res.data.resultados;

      if (coincidencias.length === 1) {
        seleccionarFuncionarioParaEditar(coincidencias[0]);
      } else {
        setResultadosBusqueda(coincidencias);
      }
    } catch (err) {
      alert(err.response?.data?.error || "Error al buscar");
    } finally {
      setProcesandoEdit(false);
    }
  };

  const seleccionarFuncionarioParaEditar = (func) => {
    setFuncionarioEdit({
      rut_busqueda: func.rut,  
      rut: func.rut,           
      nombre: func.nombre,     
      cargo: func.cargo,       
      ppu: func.ppu            
    });
    setResultadosBusqueda([]); 
  };

  const handleGuardarEdicion = async (e) => {
    e.preventDefault();
    setProcesandoEdit(true);
    try {
      const res = await api.put('/api/funcionarios/editar/', funcionarioEdit);
      alert(res.data.mensaje);
      setFuncionarioEdit(null);
      setTerminoBusqueda('');
      setTriggerGeneral(p => p + 1);
    } catch (err) { alert(err.response?.data?.error || "Error al actualizar"); } 
    finally { setProcesandoEdit(false); }
  };

  const handleEliminarFuncionario = async () => {
    if (!window.confirm(`⚠️ ADVERTENCIA:\n\n¿Eliminar permanentemente a ${funcionarioEdit.nombre} (RUT: ${funcionarioEdit.rut_busqueda})?\n\nEsta acción no se puede deshacer.`)) { return; }
    setProcesandoEdit(true);
    try {
      const res = await api.delete('/api/funcionarios/editar/', { data: { rut_busqueda: funcionarioEdit.rut_busqueda } });
      alert(res.data.mensaje);
      setFuncionarioEdit(null); 
      setTerminoBusqueda('');
      setTriggerGeneral(p => p + 1); 
    } catch (err) { alert(err.response?.data?.error || "Error al eliminar."); } 
    finally { setProcesandoEdit(false); }
  };

  // --- MAPA Y RESERVAS (Misma lógica) ---
  const parseLugares = (inputStr) => {
    const resultados = [];
    const partes = inputStr.split(',');
    partes.forEach(p => {
      const texto = p.trim().toUpperCase();
      if (texto.includes('-')) {
        const limites = texto.split('-');
        const inicio = parseInt(limites[0].replace(/[^0-9]/g, ''));
        const fin = parseInt(limites[1].replace(/[^0-9]/g, ''));
        if (!isNaN(inicio) && !isNaN(fin) && inicio <= fin) { for (let i = inicio; i <= fin; i++) resultados.push(`E.${i}`); }
      } else if (texto) { resultados.push(texto.startsWith('E.') ? texto : `E.${texto}`); }
    });
    return resultados;
  };

  const handleReservar = async (e) => {
    e.preventDefault();
    if (!reservaLugar || !reservaRut) return alert("Lugar y RUT son obligatorios");
    setProcesando(true);
    try {
      const listaLugares = parseLugares(reservaLugar);
      if(listaLugares.length === 0) throw new Error("Formato de lugar inválido");
      const listaPatentes = reservaPatente.split(',').map(p => p.trim()).filter(p => p);
      let codigosPatentes = "";
      listaLugares.forEach((lugar, index) => { if (listaPatentes[index]) codigosPatentes += `[${lugar}:${listaPatentes[index]}] `; });

      const payload = {
        lugares: listaLugares, rut: reservaRut.replace(/[^0-9kK]/g,'').toUpperCase(),
        nombre: reservaNombre || "Reserva Especial", patente: listaPatentes[0] || "", 
        motivo: codigosPatentes + (reservaMotivo || "Reserva Autorizada"), institucion: reservaInstitucion
      };
      
      const res = await api.post('/api/reservar/', payload);
      alert(res.data.mensaje);
      setReservaLugar(''); setReservaRut(''); setReservaNombre(''); setReservaPatente(''); setReservaMotivo(''); setReservaInstitucion('');
      setTriggerGeneral(p => p + 1); 
    } catch (err) { alert(err.response?.data?.error || err.message || "Error al reservar"); }
    setProcesando(false);
  };

  const enviarAlServidor = async (rut, id_lugar, datosVisita = null) => {
    setProcesando(true);
    try {
      const rutLimpio = rut ? rut.replace(/[^0-9kK]/g,'').toUpperCase() : null;
      const payload   = { rut:rutLimpio, id_lugar };
      if (datosVisita) { payload.nombre_visita = datosVisita.nombre; payload.patente = datosVisita.patente; payload.zona = datosVisita.zona; }
      
      const response = await api.post('/api/pistoleo/', payload);
      const datos    = response.data;
      setMensaje({ tipo: datos.tipo === 'entrada' ? 'exito-entrada' : 'exito-salida', texto: datos.mensaje || "OK", detalle: datos.datos ? `LUGAR: ${datos.datos.lugar}` : '' });
      if (datos.datos) setDatosMapa(datos.datos);
      setTriggerGeneral(p => p + 1); setPaso(1); setRutTemporal(''); setNombreTemporal(''); rutActualRef.current = ''; setModalVisita(false); setNombreVisita(''); setPatenteVisita(''); setZonaVisita(''); setLugarPendiente(null);
    } catch (error) {
      const ed = error.response?.data;
      if (error.response?.status === 404 && ed?.codigo === 'RUT_NO_ENCONTRADO') { setLugarPendiente(id_lugar); setModalVisita(true); setMensaje(null); } 
      else { setMensaje({ tipo:'error', texto:"ERROR", detalle: ed?.error || "Error de conexión" }); }
    }
    setInputValue(''); setProcesando(false);
    if (!modalVisita) setTimeout(() => inputRef.current?.focus(), 100);
  };

  const handleDescargarExcel = async () => {
    setDescargandoExcel(true);
    try {
      const params = new URLSearchParams();
      if (filtroNombre)  params.append('nombre', filtroNombre);
      if (filtroPatente) params.append('patente', filtroPatente);
      if (filtroInicio)  params.append('fecha_inicio', filtroInicio);
      if (filtroFin)     params.append('fecha_fin', filtroFin);
      const response = await api.get(`/api/historial/exportar/?${params}`, { responseType:'blob' });
      const url  = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a'); link.href = url; link.setAttribute('download', `Reporte_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link); link.click(); link.parentNode.removeChild(link); window.URL.revokeObjectURL(url);
    } catch { alert("Error al descargar Excel"); }
    setDescargandoExcel(false);
  };

  // Al leer un RUT, consulta el nombre y lo muestra en lugar de "RUT LEÍDO"
  const mostrarNombre = async (rutLeido) => {
    try {
      const res = await api.get('/api/consultar-rut/', { params: { rut: rutLeido } });
      if (rutActualRef.current !== rutLeido) return;   // ya se canceló o cambió de persona
      const sigueIgual = (prev) => prev && prev.tipo === 'info' && prev.rut === rutLeido;
      if (res.data.encontrado) {
        setNombreTemporal(res.data.nombre);
        setMensaje(prev => sigueIgual(prev) ? { ...prev, texto: res.data.nombre.toUpperCase(), detalle: `${res.data.cargo} · Escanee el LUGAR` } : prev);
      } else {
        setMensaje(prev => sigueIgual(prev) ? { ...prev, detalle: 'RUT no registrado (visita) · Escanee el LUGAR' } : prev);
      }
    } catch (e) { /* si la consulta falla se deja "RUT LEÍDO" y todo sigue igual */ }
  };

  const validarRut = (valor) => { return /^\d{7,8}[0-9K]$/.test(valor.replace(/\./g, '').replace(/-/g, '').toUpperCase()); };

  const handleKeyDown = (e) => {
    if (e.key !== 'Enter' || !inputValue) return;
    const v = inputValue.trim().toUpperCase();
    if (paso === 1) {
      if (v.startsWith("E.") || v.length <= 4) { enviarAlServidor(null, v); } 
      else {
        if (!validarRut(v)) { setMensaje({ tipo:'error', texto:'RUT INVÁLIDO', detalle:'Formato: 12345678-9 o 12345678K' }); setInputValue(''); return; }
        const rutLeido = v.replace(/[^0-9kK]/g,'');
        setRutTemporal(rutLeido); setNombreTemporal(''); rutActualRef.current = rutLeido; setInputValue(''); setPaso(2);
        setMensaje({ tipo:'info', texto:'RUT LEÍDO', detalle:'Escanee el LUGAR', rut: rutLeido });
        mostrarNombre(rutLeido);
      }
    } else { enviarAlServidor(rutTemporal, v); }
  };

  const cancelarCiclo = () => { setPaso(1); setRutTemporal(''); setNombreTemporal(''); rutActualRef.current = ''; setInputValue(''); setMensaje(null); inputRef.current?.focus(); };
  const confirmarVisita = () => {
    if (!nombreVisita.trim()) return alert("Debe ingresar el nombre");
    enviarAlServidor(rutTemporal, lugarPendiente, { nombre:nombreVisita, patente:patenteVisita, zona: institucionVisita ? `${zonaVisita} - ${institucionVisita}` : zonaVisita });
  };
  
  return (
    <div className="guardia-dashboard" style={{ background:'#f4f6f9' }}>

      {/* ── HEADER ── */}
      <div style={estiloHeader}>
        <div style={{ display:'flex', alignItems:'center', gap:'12px', color:'white', flexShrink:0 }}>
          <img src="/DuocUC-1024x252.png" alt="Logo" style={{ height:'44px', filter:'brightness(0) invert(1)' }} />
          <span style={{ fontWeight:'bold', fontSize:'1.1rem', whiteSpace:'nowrap' }}>PORTAL {rolUsuario?.toUpperCase()}</span>
        </div>
        <div style={{ display:'flex', gap:'8px', overflowX:'auto', flexWrap:'nowrap', paddingBottom:'2px' }}>
          <button className={`btn-toggle ${vista==='mapa'?'activo':''}`} onClick={() => setVista('mapa')}>MAPA</button>
          <button className={`btn-toggle ${vista==='historial'?'activo':''}`} onClick={() => setVista('historial')}>REGISTROS</button>
          <button className={`btn-toggle ${vista==='usuarios'?'activo':''}`} onClick={() => setVista('usuarios')}>EQUIPO</button>
          {puedeReservar && (<button className={`btn-toggle ${vista==='reservas' ? 'activo' : ''}`} onClick={() => setVista('reservas')} style={vista !== 'reservas' ? { background: '#FFB500', color: '#002D5C', fontWeight: 'bold' } : { fontWeight: 'bold' }}>RESERVAR</button>)}
          <button onClick={() => setMostrarMover(true)} title="Reubicar" style={btnIconoStyle}>🔄</button>
        </div>
      </div>

      <div className="contenido-dinamico" style={{ flex:1, display:'flex', flexDirection:'column' }}>

        {/* ── VISTA MAPA ── */}
        {vista === 'mapa' && (
          <>
            <div className={`barra-accion ${mensaje ? mensaje.tipo : ''}`} style={{ margin:'10px 20px', borderRadius:'8px' }}>
              <div className="input-zona">
                <div style={{ display:'flex', flexDirection:'column', marginRight:'12px' }}>
                  <span style={{ color:paso===2?'#FFB500':'white', fontWeight:'bold' }}>{paso === 1 ? "ESCANEAR:" : "ASIGNAR A:"}</span>
                  {paso === 2 && <span style={{ fontSize:'0.75rem', color:'#ccc', maxWidth:'200px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{nombreTemporal ? `${nombreTemporal} · ` : ''}RUT: {rutTemporal}</span>}
                </div>
                <input ref={inputRef} type="text" value={inputValue} onChange={e => setInputValue(e.target.value.replace(/[^0-9A-Za-zkK.-]/g,'').toUpperCase())} onKeyDown={handleKeyDown} placeholder={bloqueoFoco?"Pausado...":paso===1?"Esperando RUT o LUGAR...":"Esperando QR..."} disabled={procesando||bloqueoFoco||modalVisita} autoComplete="off" style={inputScannerStyle} />
                {paso === 2 && <button onClick={cancelarCiclo} style={btnCancelarStyle}>CANCELAR</button>}
              </div>
              {mensaje && (<div className="notificacion-flotante" style={{ paddingRight:'15px' }}><span className="titulo-notif">{mensaje.texto}</span><span className="detalle-notif"> {mensaje.detalle}</span></div>)}
            </div>
            <div ref={contenedorRef} style={{ flex:1, padding:'0 20px 20px', height:altoEscalado + 16, overflow:'hidden', display:'flex', justifyContent:'center', alignItems:'flex-start', boxSizing:'border-box' }}>
              <div style={{ transform:`scale(${escala})`, transformOrigin:'top center', transition:'transform 0.15s ease-out', width:ANCHO_MAPA_BASE, flexShrink:0 }}><Mapa datosIngreso={datosMapa} recargar={triggerGeneral} alCambiarModal={setBloqueoFoco} /></div>
            </div>
          </>
        )}

        {/* ── VISTA HISTORIAL ── */}
        {vista === 'historial' && (
          <div style={{ padding:'0 16px 16px', display:'flex', flexDirection:'column', flex:1, minHeight:0, overflow:'hidden' }}>
            <div style={{ background:'#e6eff6', border:'1px solid #cce5ff', borderRadius:'8px', padding:'12px 15px', margin:'12px 0', display:'flex', flexWrap:'wrap', gap:'10px', alignItems:'flex-end', flexShrink:0 }}>
              {[
                { label:'Fecha Inicio', type:'date', val:filtroInicio, set:setFiltroInicio }, { label:'Fecha Fin', type:'date', val:filtroFin, set:setFiltroFin },
                { label:'Nombre', type:'text', val:filtroNombre, set:setFiltroNombre, ph:'Ej: Juan' }, { label:'Patente', type:'text', val:filtroPatente, set:v => setFiltroPatente(v.toUpperCase()), ph:'Ej: AB12' },
              ].map(f => (
                <div key={f.label} style={{ display:'flex', flexDirection:'column', gap:'4px', minWidth:'120px' }}>
                  <label style={{ fontSize:'11px', fontWeight:'bold', color:'#002D5C' }}>{f.label}:</label>
                  <input type={f.type} value={f.val} onChange={e => f.set(e.target.value)} placeholder={f.ph} style={{ padding:'7px', border:'1px solid #ccc', borderRadius:'4px', fontSize:'13px' }} />
                </div>
              ))}
              <button onClick={handleDescargarExcel} disabled={descargandoExcel} style={{ background:'#28a745', color:'white', border:'none', padding:'9px 14px', borderRadius:'5px', fontWeight:'bold', cursor:descargandoExcel?'wait':'pointer', marginLeft:'auto', whiteSpace:'nowrap', flexShrink:0 }}>{descargandoExcel ? '⏳ GENERANDO...' : '📊 EXCEL'}</button>
            </div>
            <div className="contenedor-historial-con-filtros"><Historial /></div>
          </div>
        )}

        {/* ── VISTA USUARIOS / EQUIPO ── */}
        {vista === 'usuarios' && (
          <div style={{ padding:'16px', display:'flex', flexDirection:'row', flexWrap:'wrap', alignItems:'flex-start', gap:'16px', height:'calc(100vh - 120px)', overflowY:'auto', overflowX:'hidden', WebkitOverflowScrolling:'touch', boxSizing:'border-box' }}>
            
            {/* 1. SECCIÓN: CARGA MASIVA DE FUNCIONARIOS Y VACIADO */}
            <div style={{ ...cardStyle, flex:'1 1 100%', borderLeft: '5px solid #28a745' }}>
              <h3 style={{ margin: '0 0 15px 0', color: '#002D5C', display: 'flex', alignItems: 'center', gap: '8px' }}>📊 Actualizar Base de Datos (Masivo)</h3>
              <p style={{ fontSize: '12px', color: '#666', marginBottom: '15px' }}>Cargue un archivo (.xlsx o .csv) con las columnas: <strong>RUT, NOMBRE, CARGO, PATENTE</strong>.</p>
              
              <form onSubmit={handleCargarBD} style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
                <input 
                  id="input-bd" 
                  type="file" 
                  accept=".xlsx, .xls, .csv" 
                  onChange={(e) => setArchivoBD(e.target.files[0])} 
                  disabled={procesandoBD} 
                  style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', flex: '1 1 250px' }} 
                />
                
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button 
                    type="submit" 
                    disabled={procesandoBD || !archivoBD} 
                    style={{ padding: '12px 24px', background: procesandoBD ? '#ccc' : '#28a745', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: procesandoBD || !archivoBD ? 'not-allowed' : 'pointer' }}
                  >
                    {procesandoBD ? '⏳ Procesando...' : '🚀 Subir Excel'}
                  </button>

                  <button 
                    type="button" 
                    onClick={handleVaciarBaseDatos}
                    disabled={procesandoBD}
                    style={{ padding: '12px 24px', background: '#dc3545', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: procesandoBD ? 'not-allowed' : 'pointer' }}
                  >
                    🗑️ Vaciar Todo
                  </button>
                </div>
              </form>
            </div>

            {/* 2. SECCIÓN: BÚSQUEDA Y EDICIÓN INDIVIDUAL (CRUD) */}
            <div style={{ ...cardStyle, flex:'1 1 100%', borderLeft: '5px solid #007bff' }}>
              <h3 style={{ margin: '0 0 15px 0', color: '#002D5C', display: 'flex', alignItems: 'center', gap: '8px' }}>✏️ Buscar y Editar Funcionario</h3>
              <p style={{ fontSize: '12px', color: '#666', marginBottom: '15px' }}>Busque por RUT o Nombre para corregir sus datos o eliminarlo del sistema.</p>
              
              {!funcionarioEdit && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <form onSubmit={handleBuscarParaEditar} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <input 
                      type="text" 
                      placeholder="RUT o Nombre a buscar..." 
                      value={terminoBusqueda} 
                      onChange={e => setTerminoBusqueda(e.target.value)} 
                      style={{ ...inputCrudStyle, flex: '1 1 200px' }} 
                    />
                    <button type="submit" disabled={procesandoEdit} style={{ ...btnCrearStyle, width: 'auto', background: '#007bff' }}>
                      {procesandoEdit ? 'Buscando...' : '🔍 Buscar'}
                    </button>
                  </form>

                  {/* Lista de Múltiples Resultados */}
                  {resultadosBusqueda.length > 0 && (
                    <div style={{ background: '#f8f9fa', border: '1px solid #cce5ff', borderRadius: '8px', padding: '10px', marginTop: '10px' }}>
                      <strong style={{ fontSize: '12px', color: '#002D5C' }}>Se encontraron {resultadosBusqueda.length} coincidencias. Selecciona uno:</strong>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginTop: '10px' }}>
                        {resultadosBusqueda.map((func, idx) => (
                          <button 
                            key={idx} 
                            onClick={() => seleccionarFuncionarioParaEditar(func)}
                            style={{ padding: '8px', textAlign: 'left', background: 'white', border: '1px solid #ccc', borderRadius: '5px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between' }}
                          >
                            <span>👤 {func.nombre}</span>
                            <span style={{ color: '#666', fontSize: '12px' }}>RUT: {func.rut} - PPU: {func.ppu || 'N/A'}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {funcionarioEdit && (
                <form onSubmit={handleGuardarEdicion} style={{ display: 'flex', flexDirection: 'column', gap: '10px', background: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                    <strong style={{ color: '#007bff' }}>Editando: {funcionarioEdit.nombre} (RUT: {funcionarioEdit.rut_busqueda})</strong>
                    <button type="button" onClick={() => { setFuncionarioEdit(null); setResultadosBusqueda([]); }} style={btnEliminarStyle}>Cancelar Edición</button>
                  </div>

                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1 1 200px' }}>
                      <label style={{ fontSize: '11px', fontWeight: 'bold' }}>RUT</label>
                      <input value={funcionarioEdit.rut} onChange={e => setFuncionarioEdit({...funcionarioEdit, rut: e.target.value})} style={inputCrudStyle} />
                    </div>
                    <div style={{ flex: '1 1 200px' }}>
                      <label style={{ fontSize: '11px', fontWeight: 'bold' }}>Nombre Completo</label>
                      <input value={funcionarioEdit.nombre} onChange={e => setFuncionarioEdit({...funcionarioEdit, nombre: e.target.value})} style={inputCrudStyle} />
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1 1 200px' }}>
                      <label style={{ fontSize: '11px', fontWeight: 'bold' }}>Cargo</label>
                      <input value={funcionarioEdit.cargo} onChange={e => setFuncionarioEdit({...funcionarioEdit, cargo: e.target.value})} style={inputCrudStyle} />
                    </div>
                    <div style={{ flex: '1 1 200px' }}>
                      <label style={{ fontSize: '11px', fontWeight: 'bold' }}>Patente (PPU)</label>
                      <input value={funcionarioEdit.ppu} onChange={e => setFuncionarioEdit({...funcionarioEdit, ppu: e.target.value.toUpperCase()})} style={inputCrudStyle} maxLength={6} />
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                    <button type="button" onClick={handleEliminarFuncionario} disabled={procesandoEdit} style={{ ...btnCrearStyle, flex: 1, background: procesandoEdit ? '#ccc' : '#dc3545' }}>{procesandoEdit ? '⏳ Procesando...' : '🗑️ Eliminar Registro'}</button>
                    <button type="submit" disabled={procesandoEdit} style={{ ...btnCrearStyle, flex: 2, background: procesandoEdit ? '#ccc' : '#28a745' }}>{procesandoEdit ? '⏳ Guardando...' : '💾 Guardar Cambios'}</button>
                  </div>
                </form>
              )}
            </div>

            {/* SECCIÓN: NUEVO USUARIO (SISTEMA/GUARDIAS) */}
            <div style={{ ...cardStyle, flex:'1 1 300px', minWidth:'300px' }}>
              <h3 style={tituloCardStyle}>Nuevo Usuario (Staff)</h3>
              <form onSubmit={handleCrearUsuario} style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
                <select value={nuevoUser.rol} onChange={e => setNuevoUser({...nuevoUser, rol:e.target.value})} style={selectStyle}>
                  {['Guardia','Jefe de Seguridad','Jefe de Servicios Digitales','Director de Sede','Subdirectora de Sede','Profesor'].map(r => <option key={r} value={r}>{r}</option>)}
                </select>
                <input value={nuevoUser.username} onChange={e => setNuevoUser({...nuevoUser, username:e.target.value})} required style={inputCrudStyle} placeholder="Usuario (Login)" />
                <input type="password" value={nuevoUser.password} onChange={e => setNuevoUser({...nuevoUser, password:e.target.value})} required style={inputCrudStyle} placeholder="Contraseña" />
                <div style={{ display:'flex', gap:'6px' }}>
                  <input value={nuevoUser.first_name} onChange={e => setNuevoUser({...nuevoUser, first_name:e.target.value})} style={inputCrudStyle} placeholder="Nombre" />
                  <input value={nuevoUser.last_name} onChange={e => setNuevoUser({...nuevoUser, last_name:e.target.value})} style={inputCrudStyle} placeholder="Apellido" />
                </div>
                <button type="submit" style={btnCrearStyle}>CREAR USUARIO</button>
              </form>
            </div>

            {/* SECCIÓN: DOTACIÓN ACTUAL */}
            <div style={{ ...cardStyle, flex:'2 1 600px', minWidth:'300px', marginBottom:'16px' }}>
              <h3 style={tituloCardStyle}>Dotación Actual</h3>
              <div style={{ overflowX:'auto', WebkitOverflowScrolling:'touch', marginTop:'8px' }}>
                <table style={{ width:'100%', borderCollapse:'separate', borderSpacing:'0 4px', minWidth:'500px', fontSize:'13px', tableLayout:'fixed' }}>
                  <thead>
                    <tr style={{ background:'#bfccda', fontSize:'11px', textTransform:'uppercase' }}>
                      <th style={{ padding:'10px', width:'25%', textAlign:'left' }}>Usuario</th>
                      <th style={{ padding:'10px', width:'35%', textAlign:'left' }}>Nombre</th>
                      <th style={{ padding:'10px', width:'20%', textAlign:'center' }}>Rol</th>
                      <th style={{ padding:'10px', width:'20%', textAlign:'center' }}>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usuarios.map(u => (
                      <tr key={u.id} style={{ background:'#fff', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' }}>
                        <td style={{ padding:'10px', fontWeight:'bold', color:'#002D5C', fontSize:'12px', textAlign:'left' }}>{u.username}</td>
                        <td style={{ padding:'10px', fontSize:'12px', textAlign:'left' }}>{u.nombre_completo}</td>
                        <td style={{ padding:'10px', textAlign:'center' }}><span style={badgeStyle(u.rol)}>{u.rol}</span></td>
                        <td style={{ padding:'10px', textAlign:'center' }}><button onClick={() => handleEliminar(u.id, u.username)} style={btnEliminarStyle}>ELIMINAR</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* ── VISTA RESERVAS Y MODALES ── */}
        {vista === 'reservas' && puedeReservar && (
          <div style={{ padding:'16px', display:'flex', justifyContent:'center', alignItems:'flex-start', flex: 1, overflowY:'auto' }}>
            <div style={{ ...cardStyle, width:'100%', maxWidth:'600px', borderTop: '5px solid #FFB500' }}>
              <h3 style={tituloCardStyle}>📅 Reservar Estacionamiento</h3>
              <p style={{ fontSize: '13px', color: '#666', marginBottom: '20px' }}>Asigne un lugar específico a una visita importante o autoridad.</p>
              <form onSubmit={handleReservar} style={{ display:'flex', flexDirection:'column', gap:'12px' }}>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <div style={{ flex: '1 1 200px' }}><label style={{ fontSize: '11px', fontWeight: 'bold', color: '#002D5C' }}>LUGAR *</label><input value={reservaLugar} onChange={e => setReservaLugar(e.target.value.toUpperCase())} required style={inputCrudStyle} placeholder="Ej: E.14" disabled={procesando} /></div>
                  <div style={{ flex: '1 1 200px' }}><label style={{ fontSize: '11px', fontWeight: 'bold', color: '#002D5C' }}>RUT DE VISITA *</label><input value={reservaRut} onChange={e => setReservaRut(e.target.value)} required style={inputCrudStyle} placeholder="Ej: 12345678-9" disabled={procesando} /></div>
                </div>
                <div><label style={{ fontSize: '11px', fontWeight: 'bold', color: '#002D5C' }}>NOMBRE COMPLETO</label><input value={reservaNombre} onChange={e => setReservaNombre(e.target.value)} style={inputCrudStyle} placeholder="Ej: Juan Pérez" disabled={procesando} /></div>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <div style={{ flex: '1 1 200px' }}><label style={{ fontSize: '11px', fontWeight: 'bold', color: '#002D5C' }}>PATENTES (Separadas por coma)</label><input value={reservaPatente} onChange={e => setReservaPatente(e.target.value.toUpperCase())} style={inputCrudStyle} placeholder="Ej: AB12, CD34" disabled={procesando} /></div>
                  <div style={{ flex: '1 1 200px' }}><label style={{ fontSize: '11px', fontWeight: 'bold', color: '#002D5C' }}>MOTIVO / DESTINO</label><input value={reservaMotivo} onChange={e => setReservaMotivo(e.target.value)} style={inputCrudStyle} placeholder="Ej: Visita" disabled={procesando} /></div>
                </div>
                <div style={{ flex: '1 1 200px' }}><label style={{ fontSize: '11px', fontWeight: 'bold', color: '#002D5C' }}>COLEGIO / EMPRESA</label><input value={reservaInstitucion} onChange={e => setReservaInstitucion(e.target.value)} style={inputCrudStyle} placeholder="Ej: Duoc UC" disabled={procesando} /></div>
                <button type="submit" style={{ ...btnCrearStyle, marginTop: '15px', background: procesando ? '#ccc' : '#28a745', fontSize: '14px' }} disabled={procesando}>{procesando ? '⏳ PROCESANDO...' : '✅ CONFIRMAR RESERVA'}</button>
              </form>
            </div>
          </div>
        )}

        {modalVisita && (
          <div style={{ position:'fixed', top:0, left:0, width:'100vw', height:'100dvh', background:'rgba(0,0,0,0.8)', zIndex:9999, display:'flex', justifyContent:'center', alignItems:'flex-start', padding:'max(50px, 8dvh) 16px 16px', boxSizing:'border-box', overflowY:'auto' }}>
            <div style={{ background:'white', padding:'25px', borderRadius:'10px', width:'100%', maxWidth:'400px', position:'relative', borderTop:'5px solid #002D5C', flexShrink:0 }}>
              <h2 style={{ color:'#002D5C', marginTop:0 }}>👤 NUEVA VISITA</h2>
              <p style={{ fontSize:'13px', color:'#666' }}>Destino: <strong>{lugarPendiente}</strong></p>
              <input ref={inputNombreRef} type="text" placeholder="Nombre Completo *" value={nombreVisita} onChange={e => setNombreVisita(e.target.value)} style={inputModalStyle} />
              <input type="text" placeholder="Patente (Opcional)" value={patenteVisita} onChange={e => setPatenteVisita(e.target.value.toUpperCase())} style={inputModalStyle} maxLength={6} />
              <input type="text" placeholder="Dirección / Destino" value={zonaVisita} onChange={e => setZonaVisita(e.target.value)} style={inputModalStyle} maxLength={30} />
              <input type="text" placeholder="Colegio / Empresa (Opcional)" value={institucionVisita} onChange={e => setInstitucionVisita(e.target.value)} style={inputModalStyle} maxLength={40} />
              <div style={{ display:'flex', gap:'10px', marginTop:'10px' }}><button onClick={() => { setModalVisita(false); cancelarCiclo(); }} style={btnCancelModalStyle}>CANCELAR</button><button onClick={confirmarVisita} style={btnConfirmModalStyle}>REGISTRAR</button></div>
            </div>
          </div>
        )}

      </div>
      {mostrarMover && (
        <div style={{ position:'fixed', top:0, left:0, width:'100vw', height:'100dvh', background:'rgba(0,0,0,0.8)', zIndex:9999, display:'flex', justifyContent:'center', alignItems:'flex-start', padding:'max(50px, 8dvh) 16px 16px', boxSizing:'border-box', overflowY:'auto' }}>
          <div style={{ background:'white', padding:'25px', borderRadius:'10px', width:'100%', maxWidth:'400px', position:'relative', borderTop:'5px solid #002D5C', flexShrink:0 }}>
            <button onClick={() => setMostrarMover(false)} style={closeBtnStyle}>✖️</button>
            <h3 style={{ color:'#002D5C' }}>🔄 Reubicar Vehículo</h3>
            <p style={{ fontSize:'12px', color:'#666' }}>Mover un auto de un lugar a otro.</p>
            <div style={{ display:'flex', gap:'8px', marginBottom:'12px', flexWrap:'wrap' }}><input id="inputOrigen" placeholder="Origen (Ej: E.5)" style={{ ...inputModalStyle, flex:1, minWidth:'120px' }} /><input id="inputDestino" placeholder="Destino (Ej: E.10)" style={{ ...inputModalStyle, flex:1, minWidth:'120px' }} /></div>
            <input id="inputClaveMover" type="password" placeholder="Contraseña de usuario" style={{ ...inputModalStyle, borderColor:'#dc3545', background:'#fff8f8' }} />
            <button onClick={async () => {
              const o = document.getElementById('inputOrigen').value; const d = document.getElementById('inputDestino').value; const p = document.getElementById('inputClaveMover').value;
              if (!o || !d || !p) return alert("Faltan datos");
              try { await api.post('/api/cambiar-lugar/', { lugar_origen:o, lugar_destino:d, password:p }); alert("✅ Vehículo movido"); setMostrarMover(false); setTriggerGeneral(t => t+1); } catch (e) { alert(e.response?.data?.error || "Error"); }
            }} style={{ ...btnConfirmModalStyle, background:'#007bff' }}>CONFIRMAR</button>
          </div>
        </div>
      )}
    </div>
  );
};

const estiloHeader         = { background:'#002D5C', padding:'10px 15px', display:'flex', justifyContent:'space-between', alignItems:'center', boxShadow:'0 2px 5px rgba(0,0,0,0.2)', flexWrap:'wrap', gap:'8px' };
const btnIconoStyle        = { background:'rgba(255,255,255,0.2)', border:'1px solid white', color:'white', borderRadius:'50%', width:'34px', height:'34px', cursor:'pointer', display:'flex', justifyContent:'center', alignItems:'center', flexShrink:0 };
const inputScannerStyle    = { border:'none', background:'white', borderRadius:'4px', padding:'9px', width:'240px', maxWidth:'320px', textAlign:'center', fontWeight:'bold', fontSize:'16px', color:'black' };
const btnCancelarStyle     = { marginLeft:'10px', background:'#dc3545', color:'white', border:'none', padding:'9px 14px', borderRadius:'4px', cursor:'pointer', fontWeight:'bold' };
const cardStyle            = { background:'white', padding:'22px', borderRadius:'8px', boxShadow:'0 4px 15px rgba(0,0,0,0.1)' };
const tituloCardStyle      = { color:'#002D5C', marginTop:0, borderBottom:'2px solid #FFB500', paddingBottom:'8px' };
const selectStyle          = { padding:'9px', width:'100%', border:'1px solid #002D5C', borderRadius:'5px', background:'#f0f7ff', fontWeight:'bold' };
const inputCrudStyle       = { padding:'9px', width:'100%', border:'1px solid #ccc', borderRadius:'5px', boxSizing:'border-box' };
const btnCrearStyle        = { background:'#002D5C', color:'white', padding:'11px', border:'none', borderRadius:'5px', cursor:'pointer', fontWeight:'bold', width:'100%' };
const btnEliminarStyle     = { background:'transparent', border:'1px solid #dc3545', color:'#dc3545', padding:'4px 8px', borderRadius:'4px', cursor:'pointer', fontSize:'11px' };
const badgeStyle = (rol)   => ({ background: rol==='Jefe de Seguridad'?'#d4edda':(rol==='Visita'?'#fff3cd':'#cce5ff'), color: rol==='Jefe de Seguridad'?'#22990a':(rol==='Visita'?'#856404':'#004085'), padding:'3px 7px', borderRadius:'4px', fontSize:'11px', fontWeight:'bold' });
const inputModalStyle      = { width:'100%', padding:'10px', marginBottom:'10px', border:'1px solid #ccc', borderRadius:'5px', boxSizing:'border-box', fontSize:'16px' };
const btnCancelModalStyle  = { flex:1, padding:'11px', background:'#ccc', border:'none', borderRadius:'5px', cursor:'pointer', fontWeight:'bold' };
const btnConfirmModalStyle = { flex:1, padding:'11px', background:'#002D5C', color:'white', border:'none', borderRadius:'5px', cursor:'pointer', fontWeight:'bold' };
const closeBtnStyle        = { position:'absolute', top:'10px', right:'10px', background:'transparent', border:'none', fontSize:'20px', cursor:'pointer' };

export default PanelAdmin;